// ===== UPDATE EMAIL SERVICE =====

// services/emailService.js - Enhanced with verification
import api from '../utils/api';

export const emailService = {
    // Email signup with verification
    saveEmail: async (email, source = 'website') => {
        try {
            const response = await api.post('/email/save', { email, source });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 🆕 NEW: Verify email with token
    verifyEmail: async (token) => {
        try {
            const response = await api.get(`/email/verify-email?token=${token}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 🆕 NEW: Resend verification email
    resendVerification: async (email) => {
        try {
            const response = await api.post('/email/save', { email, source: 'resend' });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    }
};
